import agreementActionKeys from './agreementAddOnActionKeys';
import service from './agreementAddOnService';

const callService = (actionKey, apiMethod, ...params) => ({
  type: actionKey,
  payload: service[apiMethod](...params),
});

const createAndActivateBusinessManagementToolsSubscription =
  (serviceProviderId, oneTimeToken) =>
    callService(
      agreementActionKeys.CREATE_AND_ACTIVATE_BUSINESS_MANAGEMENT_TOOLS_SUBSCRIPTION,
      'createAndActivateBusinessManagementToolsSubscription',
      serviceProviderId,
      oneTimeToken,
    );

const getBusinessManagementToolsAgreementAddOnEligibility = (serviceProviderId, oneTimeToken) =>
  callService(
    agreementActionKeys.GET_BUSINESS_MANAGEMENT_TOOLS_AGREEMENT_ADD_ON_ELIGIBILITY,
    'getBusinessManagementToolsAgreementAddOnEligibility',
    serviceProviderId,
    oneTimeToken,
  );

const cancelBusinessManagementToolsSubscription =
  serviceProviderId =>
    callService(
      agreementActionKeys.CANCEL_BUSINESS_MANAGEMENT_TOOLS_SUBSCRIPTION,
      'cancelBusinessManagementToolsSubscription',
      serviceProviderId,
    );

export default {
  createAndActivateBusinessManagementToolsSubscription,
  getBusinessManagementToolsAgreementAddOnEligibility,
  cancelBusinessManagementToolsSubscription,
};



// WEBPACK FOOTER //
// ./src/app/common/agreementAddOn/agreementAddOnActions.js